import { DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutDataFusionErrorQuickInfo extends Layout {
    labelM: Label;
    panelMain: Panel;
    sourceDatafusionMapError: DataSource;
    tableErrors: Table;
}
